<template>
  <div style="width: 100%;height: 600px;">
    <xr-table ref="xrTable" :configure="configure"></xr-table>
  </div>
</template>

<script>
  import  XrTable from '../../../XrTable/simple'

  export default {
    name: "pageSelectOrg",
    data (){
      return {
        configure: {
          url: '/web/service?method=tCoreRole_list',
          isShowSearch: false,
          defaultNoLoadData: true,
          isSelectFirst: true,
          pagination: false,
          idField: 'id',
          columns: [
            {
              field: 'radio',
              width: 60,
            },
            {
              field: 'roleName',
              title: '角色名称',
              width: 200,
              condition: {
                searchType: 'input',
                searchName: 'roleNameSearch',
                value:''
              },
            },
            {
              field: 'roleDesc',
              title: '描述',
              width: 200,
              condition: {
                searchType: 'input',
                searchName: 'roleDescSearch',
                value:''
              },
            }
          ],
          toolbar: [
            {
              text: '确认',
              iconCls: 'wk wk-list2',
              that: this,
              handler: function () {
                this.that.getSelectedValue();
              }
            },
            {
              text: '取消',
              iconCls: 'wk wk-cancel2',
              that: this,
              handler: function () {
                this.that.handleCloseDialog();
              }
            }
          ]
        },
      }
    },
    components: {
      XrTable
    },
    methods: {
      init() {
        this.$refs.xrTable.getData();
      },
      //关闭窗口
      handleCloseDialog(){
        this.dialogVisible = false;
        this.$emit('cancelMethod');
      },
      //获取选中的值
      getSelectedValue(){
        let radio_value = this.$refs.xrTable.radio_value;
        let radio_label = '';
        if(this.$refs.xrTable.radio_row){
          radio_label = this.$refs.xrTable.radio_row.roleName;
        }
        if(!radio_value){
          alert('请选择！');
          return false;
        }
        this.$emit('confirmMethod',radio_value,radio_label);
      }
    }
  }
</script>





// WEBPACK FOOTER //
// src/components/PageSelect/core/role/rolePageSelect.vue